/* preorder-notice: shows the timing sheet when the cart mixes pre-order items with items in stock.
   State comes from sections/preorder-notice.liquid (server side, re-fetched after every cart change). */
(function () {
  var root = document.querySelector('[data-po]'); if (!root) return;
  var stateEl = document.querySelector('[data-po-state]'), tpl = document.querySelector('[data-po-row]'), list = root.querySelector('[data-po-list]');
  var KEY = 'wj_po_ack', onCart = /^\/cart\/?$/.test(location.pathname);
  var state = parse(stateEl && stateEl.textContent);
  function parse(t) { try { return JSON.parse(t); } catch (e) { return null; } }
  function sig(s) { return s.far.map(function (f) { return f.key + ':' + f.qty; }).sort().join('|') + '#' + s.now_n; }
  function acked(s) { try { return sessionStorage.getItem(KEY) === sig(s); } catch (e) { return false; } }
  function ack(s) { try { sessionStorage.setItem(KEY, sig(s)); } catch (e) {} }
  function mixed(s) { return !!(s && s.enabled && s.far_n > 0 && s.now_n > 0); }
  function render(s) {
    list.innerHTML = '';
    s.far.forEach(function (f) {
      var n = tpl.content.cloneNode(true), li = n.querySelector('li'), im = n.querySelector('img');
      li.setAttribute('data-key', f.key);
      if (f.img) im.src = f.img; else im.remove();
      var name = f.title + (f.variant && f.variant !== 'Default Title' ? ' · ' + f.variant : '') + (f.qty > 1 ? ' × ' + f.qty : '');
      n.querySelector('.po__name').textContent = name;
      n.querySelector('.po__ship').textContent = f.ship || '';
      list.appendChild(n);
    });
  }
  function open(s) { render(s); root.hidden = false; document.documentElement.classList.add('po-open'); }
  function close() { root.hidden = true; document.documentElement.classList.remove('po-open'); }
  function refresh() {
    return fetch('/?sections=preorder-notice', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (j) {
      var html = j['preorder-notice'] || '', m = html.match(/data-po-state>([\s\S]*?)<\/script>/);
      if (!m) return null; state = parse(m[1]); return state;
    }).catch(function () { return null; });
  }
  /* 11.10: while the MAT companions guard holds the cart, it speaks first */
  function maybe(s) { if (document.documentElement.classList.contains('acg-block')) { close(); return; } if (mixed(s) && !acked(s)) open(s); else if (!mixed(s)) close(); }
  function post(url, body) { return fetch(url, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) }); }

  /* Dror 27.9: wherever the visitor is, a mixed cart gets the sheet once per cart state */
  maybe(state);
  document.addEventListener('cart:update', function (e) {
    if (e.detail && e.detail.source === 'preorder-notice') return;
    setTimeout(function () { refresh().then(function (s) { if (s) maybe(s); }); }, 300);
  });
  root.addEventListener('click', function (e) {
    if (e.target.closest('[data-po-close]')) { ack(state); close(); return; }
    if (e.target.closest('[data-po-wait]')) {
      ack(state); close();
      post('/cart/update.js', { attributes: { preorder_hold: 'accepted, ships together' } }).catch(function () {});
      return;
    }
    var rm = e.target.closest('[data-po-remove]'); if (!rm) return;
    var li = rm.closest('[data-key]'), key = li.getAttribute('data-key');
    rm.disabled = true; rm.textContent = '…';
    fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (c) {
      var upd = {}; upd[key] = 0;
      /* the last pre-order item takes its gift lines with it */
      var farLeft = state.far.filter(function (f) { return f.key !== key; }).length;
      if (farLeft === 0) c.items.forEach(function (i) { if (i.properties && i.properties._gift) upd[i.key] = 0; });
      return post('/cart/update.js', { updates: upd });
    }).then(function () { return refresh(); }).then(function (s) {
      if (s && mixed(s)) render(s); else close();
      if (onCart) { location.reload(); return; }
      document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { source: 'preorder-notice' } }));
    }).catch(function () { rm.disabled = false; rm.textContent = 'Remove'; });
  });
})();
